"use strict";

var _regeneratorRuntime = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteNameRegistry = exports.transferNameOwnership = exports.updateNameRegistryData = exports.createNameRegistry = exports.HASH_PREFIX = exports.NAME_PROGRAM_ID = void 0;

var web3_js_1 = require("@solana/web3.js");

var instructions_1 = require("./instructions");

var state_1 = require("./state");

var utils_1 = require("./utils");

var utils_2 = require("./utils"); ////////////////////////////////////////////////////////////


exports.NAME_PROGRAM_ID = new web3_js_1.PublicKey('namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX');
exports.HASH_PREFIX = 'SPL Name Service'; ////////////////////////////////////////////////////////////

/**
 * Creates a name account with the given rent budget, allocated space, owner and class.
 *
 * @param connection The solana connection object to the RPC node
 * @param name The name of the new account
 * @param space The space in bytes allocated to the account
 * @param payerKey The allocation cost payer
 * @param nameOwner The pubkey to be set as owner of the new name account
 * @param lamports The budget to be set for the name account. If not specified, it'll be the minimum for rent exemption
 * @param nameClass The class of this new name
 * @param parentName The parent name of the new name. If specified its owner needs to sign
 * @returns
 */

function createNameRegistry(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _createNameRegistry.apply(this, arguments);
}

function _createNameRegistry() {
  _createNameRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(connection, name, space, payerKey, nameOwner, lamports, nameClass, parentName) {
    var hashed_name, nameAccountKey, balance, nameParentOwner, parentAccount, createNameInstr;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return utils_2.getHashedName(name);

          case 2:
            hashed_name = _context.sent;
            _context.next = 5;
            return utils_2.getNameAccountKey(hashed_name, nameClass, parentName);

          case 5:
            nameAccountKey = _context.sent;

            if (!lamports) {
              _context.next = 10;
              break;
            }

            _context.t0 = lamports;
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return connection.getMinimumBalanceForRentExemption(space);

          case 12:
            _context.t0 = _context.sent;

          case 13:
            balance = _context.t0;

            if (!parentName) {
              _context.next = 19;
              break;
            }

            _context.next = 17;
            return utils_2.getNameOwner(connection, parentName);

          case 17:
            parentAccount = _context.sent;
            nameParentOwner = parentAccount.owner;

          case 19:
            createNameInstr = instructions_1.createInstruction(exports.NAME_PROGRAM_ID, web3_js_1.SystemProgram.programId, nameAccountKey, nameOwner, payerKey, hashed_name, new utils_1.Numberu64(balance), new utils_2.Numberu32(space), nameClass, parentName, nameParentOwner);
            return _context.abrupt("return", createNameInstr);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createNameRegistry.apply(this, arguments);
}

exports.createNameRegistry = createNameRegistry;
/**
 * Overwrite the data of the given name registry.
 *
 * @param connection The solana connection object to the RPC node
 * @param name The name of the name registry to update
 * @param offset The offset to which the data should be written into the registry
 * @param input_data The data to be written
 * @param nameClass The class of this name, if it exsists
 * @param nameParent The parent name of this name, if it exists
 */

function updateNameRegistryData(_x9, _x10, _x11, _x12, _x13, _x14) {
  return _updateNameRegistryData.apply(this, arguments);
}

function _updateNameRegistryData() {
  _updateNameRegistryData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(connection, name, offset, input_data, nameClass, nameParent) {
    var hashed_name, nameAccountKey, signer, updateInstr;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return utils_2.getHashedName(name);

          case 2:
            hashed_name = _context2.sent;
            _context2.next = 5;
            return utils_2.getNameAccountKey(hashed_name, nameClass, nameParent);

          case 5:
            nameAccountKey = _context2.sent;

            if (!nameClass) {
              _context2.next = 10;
              break;
            }

            signer = nameClass;
            _context2.next = 13;
            break;

          case 10:
            _context2.next = 12;
            return state_1.NameRegistryState.retrieve(connection, nameAccountKey);

          case 12:
            signer = _context2.sent.owner;

          case 13:
            updateInstr = instructions_1.updateInstruction(exports.NAME_PROGRAM_ID, nameAccountKey, new utils_2.Numberu32(offset), input_data, signer);
            return _context2.abrupt("return", updateInstr);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateNameRegistryData.apply(this, arguments);
}

exports.updateNameRegistryData = updateNameRegistryData;
/**
 * Change the owner of a given name account.
 *
 * @param connection The solana connection object to the RPC node
 * @param name The name of the name account
 * @param newOwner The new owner to be set
 * @param curentNameOwner the current name Owner
 * @param nameClass The class of this name, if it exsists
 * @param nameParent The parent name of this name, if it exists
 * @returns
 */

function transferNameOwnership(_x15, _x16, _x17, _x18, _x19) {
  return _transferNameOwnership.apply(this, arguments);
}

function _transferNameOwnership() {
  _transferNameOwnership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(connection, name, newOwner, nameClass, nameParent) {
    var hashed_name, nameAccountKey, curentNameOwner, transferInstr;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return utils_2.getHashedName(name);

          case 2:
            hashed_name = _context3.sent;
            _context3.next = 5;
            return utils_2.getNameAccountKey(hashed_name, nameClass, nameParent);

          case 5:
            nameAccountKey = _context3.sent;

            if (!nameClass) {
              _context3.next = 10;
              break;
            }

            curentNameOwner = nameClass;
            _context3.next = 13;
            break;

          case 10:
            _context3.next = 12;
            return state_1.NameRegistryState.retrieve(connection, nameAccountKey);

          case 12:
            curentNameOwner = _context3.sent.owner;

          case 13:
            transferInstr = instructions_1.transferInstruction(exports.NAME_PROGRAM_ID, nameAccountKey, newOwner, curentNameOwner, nameClass);
            return _context3.abrupt("return", transferInstr);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _transferNameOwnership.apply(this, arguments);
}

exports.transferNameOwnership = transferNameOwnership;
/**
 * Delete the name account and transfer the rent to the target.
 *
 * @param connection The solana connection object to the RPC node
 * @param name The name of the name account
 * @param refundTargetKey The refund destination address
 * @param nameClass The class of this name, if it exsists
 * @param nameParent The parent name of this name, if it exists
 * @returns
 */

function deleteNameRegistry(_x20, _x21, _x22, _x23, _x24) {
  return _deleteNameRegistry.apply(this, arguments);
}

function _deleteNameRegistry() {
  _deleteNameRegistry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(connection, name, refundTargetKey, nameClass, nameParent) {
    var hashed_name, nameAccountKey, nameOwner, changeAuthoritiesInstr;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return utils_2.getHashedName(name);

          case 2:
            hashed_name = _context4.sent;
            _context4.next = 5;
            return utils_2.getNameAccountKey(hashed_name, nameClass, nameParent);

          case 5:
            nameAccountKey = _context4.sent;

            if (!nameClass) {
              _context4.next = 10;
              break;
            }

            nameOwner = nameClass;
            _context4.next = 13;
            break;

          case 10:
            _context4.next = 12;
            return state_1.NameRegistryState.retrieve(connection, nameAccountKey);

          case 12:
            nameOwner = _context4.sent.owner;

          case 13:
            changeAuthoritiesInstr = instructions_1.deleteInstruction(exports.NAME_PROGRAM_ID, nameAccountKey, refundTargetKey, nameOwner);
            return _context4.abrupt("return", changeAuthoritiesInstr);

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _deleteNameRegistry.apply(this, arguments);
}

exports.deleteNameRegistry = deleteNameRegistry;